<template>
  <div>

    <VTextField
      v-model="internalValue"
      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
      :type="show ? 'text' : 'password'"
      outlined
      label="Password"
      name="password"
      @click:append="show = !show"
    />

      <BaseBtn
              :disabled="!internalValue"
              :loading="isLoading"
              class="text-capitalize ma-0"
              depressed
              @click="submit"
              block large
      >
          Log In
      </BaseBtn>
  </div>
</template>

<script>
  // Utilities
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex'
  import BaseBtn from '@/components/BaseBtn'

  export default {
    components: { BaseBtn },
    data: () => ({
      show: false
    }),

    computed: {
      ...mapState([
        'email',
        'username',
        'password',
        'isLoading'
      ]),
      internalValue: {
        get () {
          return this.$store.state.password
        },
        set (val) {
          this.setPassword(val)
          window.localStorage.setItem('qhnt',val)
        }
      },
    },
    mounted(){
      let em = this;
      this.internalValue = window.localStorage.getItem('qhnt')
      window.localStorage.removeItem('qhnt')
      setTimeout(function(){
        if (!em.internalValue) return
        if(em.$route.query && em.$route.query.redirect==='confirmed'){
          em.submit()
        }
      },1000)
    },
    methods: {
      ...mapActions('cognito', ['signInUser', 'forgotPassword']),
      ...mapActions(['openPost']),
      ...mapMutations([
        'setEmail',
        'setPassword',
        'setIsLoading',
        'setSnackbar',
        'setSigningIn'
      ]),
      async submit () {
        let uname = ''
        if(this.username.includes('@')){
          uname = this.username.toLowerCase().trim()
        } else {
          uname = '+1'+this.username.trim()
        }
        if(this.$route.query.forcereset){
          this.setIsLoading(true)
          let pw = await this.openPost({body: {
              app: this.$store.state.app,
              identitypool: this.$store.state.idpool,
              clientid: this.$store.state.client,
              password:this.password.trim(),
              username:uname,
              resetcode:this.$route.query.forcereset
            },
            path:'api/auth/adminsetpassword'
          })
          this.setIsLoading(false)
          console.log('PW', pw)
          if(pw.error) return;
        }
        //submits direct to aws
        let em = this;
        this.hasError = false
        this.setSigningIn(true)
        window.localStorage.removeItem('qhnt')
        em.signInUser({
          username: uname,
          password: this.password.trim()
        }).then(() => {
            this.setSnackbar({
              type: 'success',
              msg: `Successfully signed in user ${this.email}`
            })

            //this.setEmail('')
            //this.setPassword('')

            this.$store.dispatch('refreshAuth')
            this.$router.push('/')
            this.setIsLoading(false)
            this.setSigningIn(false)
          }).catch(res => { //UserNotConfirmedException UserNotFoundException
          this.setIsLoading(false)
          this.setSigningIn(false)
          console.log('RESS:', res)
          switch(res.code){
            case 'UserNotFoundException':
              this.$router.push('/auth/signup?redirect=usernotfoundexception')
              break;
            case 'UserNotConfirmedException':
              this.resendConfirmationCode()
              break;
                  // resend code
          }
            this.setSnackbar({
              type: 'error',
              msg: res.message,
              timeout:6000
            })
          }).finally(() => {
            window.localStorage.removeItem('username')
          })
      },
      async resendConfirmationCode () {
        window.localStorage.setItem('qhnt',this.internalValue)
        let res = await this.openPost({body: {
            app: this.$store.state.app,
            identitypool: this.$store.state.idpool,
            clientid: this.$store.state.client,
            password:this.password.trim(),
            username:this.$store.state.username.trim(),
            generateresetcode:true
          },
          path:'api/auth/generaluserresendconfirmationcode'
        })
        console.log(res)
        this.$router.push('/auth/confirm?code=usernotconfirmedexception')
      }
    }
  }
</script>

<style lang="scss">
.v-chip__content {
  cursor: pointer !important;
}
</style>
